import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TimeWindowSelectorPage } from './time-window-selector.page';

const routes: Routes = [
  {
    path: '',
    component: TimeWindowSelectorPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TimeWindowSelectorPageRoutingModule {}
